import { TableName } from '../../../tables'
import { useLoaders } from '../../common'
import { Request } from '../state/types'
import { useSystemStateHooks } from '../state/hooks'
import { DynamoSystemApi } from '../../../services'
import { getActiveFilter } from '../../../features/data-types'

export const useRequestLoaders = () => {
    const systemHooks = useSystemStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadAllRequests = async (active = false) => {
            const { loadMultiple } = loaders(companyId, DynamoSystemApi)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.REQUESTS, options)
            return response.dataTypes as Request[]
        }
        
        const loadUserRequests = async (
            userId: string,
            dbRequest = false
        ) => {
            const { loadAll } = loaders(companyId, DynamoSystemApi)
            const requests = await loadAll(TableName.REQUESTS, dbRequest) as Request[]
            return requests.filter(request => request.userId === userId)
        }

        return {
            loadAllRequests,
            loadUserRequests
        }
    }
}
